import type { User } from '@promtver/contracts';

/**
 * Хранилище сессии панели администратора.
 * Ключ отличается от панели предприятия и Mini App — сессии не пересекаются.
 */
const STORAGE_KEY = 'promtver.admin.session.v1';

export interface StoredSession {
  accessToken: string;
  refreshToken: string;
  /** Момент истечения access-токена (мс epoch). */
  expiresAt: number;
  user: User;
}

let memorySession: StoredSession | null = null;
let loaded = false;

function readStorage(): StoredSession | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredSession;
    if (!parsed || typeof parsed.accessToken !== 'string') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function getSession(): StoredSession | null {
  if (!loaded) {
    loaded = true;
    memorySession = readStorage();
  }
  return memorySession;
}

export function setSession(session: StoredSession | null): void {
  memorySession = session;
  loaded = true;
  try {
    if (session) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Приватный режим браузера: сессия остаётся только в памяти вкладки.
  }
}

export function clearSession(): void {
  setSession(null);
}
